document.addEventListener("DOMContentLoaded", function () {
    function getPlanningTipsRoot() {
        return document.getElementById("plannigBeforeStarting")
            || document.getElementById("start-points")
            || document.getElementById("planifyPage")
            || document.body;
    }

    function getPlanningTipsContentRoot() {
        return document.getElementById("content-question") || getPlanningTipsRoot();
    }

    function toggleSection(section) {
        const planningTipsRoot = getPlanningTipsRoot();
        if (!planningTipsRoot) return;

        let target = document.getElementById(section);
        let icon = document.getElementById("icon-" + section);

        if (!target || !planningTipsRoot.contains(target)) return;

        if (target.classList.contains("p-expanded")) {
            target.style.maxHeight = "0px";
            target.style.overflow = "hidden";
            target.classList.remove("p-expanded");
            if (icon) {
                icon.textContent = "+";
            }
            return;
        }

        planningTipsRoot.querySelectorAll(".p-collapsible[id]").forEach(other => {
            let otherIcon = document.getElementById("icon-" + other.id);
            if (planningTipsRoot.contains(other)) {
                other.style.maxHeight = "0px";
                other.style.overflow = "hidden";
                other.classList.remove("p-expanded");
            }
            if (otherIcon) {
                otherIcon.textContent = "+";
            }
        });

        target.style.maxHeight = target.scrollHeight + "px";
        target.style.overflow = "hidden";
        target.classList.add("p-expanded");
        if (icon) {
            icon.textContent = "-";
        }

        let firstQuestion = target.querySelector(".p-question");
        if (firstQuestion) {
            let onclickValue = firstQuestion.getAttribute("onclick") || "";
            let firstQuestionMatch = onclickValue.match(/'([^']+)'/);
            if (firstQuestionMatch && firstQuestionMatch[1]) {
                showContent(null, firstQuestionMatch[1]);
            }
        }
    }

    function showContent(event, contentId) {
        const planningTipsContentRoot = getPlanningTipsContentRoot();
        if (!planningTipsContentRoot) return;

        planningTipsContentRoot.querySelectorAll(".p-content").forEach(el => el.classList.add("p-hidden"));

        let contentToShow = document.getElementById(contentId);
        if (contentToShow && planningTipsContentRoot.contains(contentToShow)) {
            contentToShow.classList.remove("p-hidden");
        }

        const planningTipsRoot = getPlanningTipsRoot();
        planningTipsRoot.querySelectorAll(".p-question").forEach(el => {
            el.classList.remove("p-text-primary", "p-underline");
            el.classList.add("p-text-gray");
        });

        if (event) {
            event.target.classList.add("p-text-primary", "p-underline");
            event.target.classList.remove("p-text-gray");
        } else {
            let selectedQuestion = planningTipsRoot.querySelector(`[onclick="showContent(event, '${contentId}')"]`);
            if (selectedQuestion) {
                selectedQuestion.classList.add("p-text-primary", "p-underline");
                selectedQuestion.classList.remove("p-text-gray");
            }
        }
    }

    window.toggleSection = toggleSection;
    window.showContent = showContent;

    const hasPlanningTipsDom = document.getElementById("mochila") || document.getElementById("salud");
    if (!hasPlanningTipsDom) return;

    const planningTipsRoot = getPlanningTipsRoot();
    planningTipsRoot.querySelectorAll(".p-collapsible").forEach(collapsible => {
        collapsible.style.overflow = "hidden";
        if (collapsible.classList.contains("p-expanded")) {
            collapsible.style.maxHeight = collapsible.scrollHeight + "px";
        } else {
            collapsible.style.maxHeight = "0px";
        }
    });

    let defaultSection = document.getElementById("mochila") || document.getElementById("salud");
    if (defaultSection && planningTipsRoot.contains(defaultSection)) {
        defaultSection.style.maxHeight = defaultSection.scrollHeight + "px";
        defaultSection.style.overflow = "hidden";
        defaultSection.classList.add("p-expanded");
        let defaultIcon = document.getElementById("icon-" + defaultSection.id);
        if (defaultIcon) defaultIcon.textContent = "-";
    }

    if (document.getElementById("mochila-1")) {
        showContent(null, "mochila-1");
    }
});
